import { createFileRoute } from '@tanstack/react-router';
import CampanyDocumentOverview from '@/modules/documents/pages/campany-document-overview';

import { Route as CompanyDocumentPageRoute } from './route';

export const Route = createFileRoute(
  '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/',
)({
  head: () => ({
    meta: [{ title: 'Visão Geral do Documento da Empresa' }],
  }),
  component: function CompanyDocumentOverviewPage() {
    return (
      <CampanyDocumentOverview
        companyDocument={CompanyDocumentPageRoute.useLoaderData()}
      />
    );
  },
});
